import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Card,
  CardContent,
  Chip,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Avatar, Snackbar, Alert
} from '@mui/material';
import { motion } from "framer-motion";
import {
  CheckCircle, Timeline,
  AccessTime,
  Assessment,
  Task,
  AssignmentTurnedIn,
  ThumbUp,
  History,
  ArrowBack,
  Group,
  Person, PendingActions
} from "@mui/icons-material";
import EmployeeGoalsReview from './EmployeeGoalsReview';
import EmployeePerformanceReview from './EmployeePerformanceReview';
import { localAxiosGet } from '../../../Axios/axios';
import axios from 'axios';
import { Loader } from '../../../components/loade';


const ManagerPerformanceReviewDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('Submitted For Review');
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dashboardCardDetails, setDashboardCardDetails] = useState({
    submitted_for_review: 0,
    pending_goals: 0,
    acknowledged_appraisals: 0,
    pending_appraisals: 0
  });
  const [goalsTable, setGoalsTable] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const userId = localStorage.getItem('userId');
  

  useEffect(() => {
    fetchDashboardCardStats();
    handleCategoryClick('submitted_for_review');
  }, []);

  const fetchDashboardCardStats = async () => {
    try {
      const response = await axios(localAxiosGet(`/performancemanagement/stats?reporting_manager_id=${userId}`));
      if (response.data.status === 'SUCCESS') {
        setDashboardCardDetails(response.data.result);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Error in fetching Dashboard Stats', error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || 'An error occurred',
        severity: 'error'
      });
    }
  };


  useEffect(() => {
    setFilteredEmployees(goalsTable);

  }, [goalsTable]);


  const getStatusChip = (status) => {
    switch (status) {
      case 'Submitted For Review':
        return <Chip label="Submitted For Review" color="warning" size="small" icon={<AccessTime fontSize="small" />} />;
      case 'Pending':
        return <Chip label="Pending" color="error" size="small" icon={<PendingActions fontSize="small" />} />;
      case 'Completed':
        return <Chip label="Completed" color="success" size="small" icon={<CheckCircle fontSize="small" />} />;
      case 'Acknowledged':
        return <Chip label="Acknowledged" color="primary" size="small" icon={<ThumbUp fontSize="small" />} />;
      default:
        return <Chip label={status} color="default" size="small" />;
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedEmployee(null);
    if (newValue === 0) {
      setSelectedCategory('goals_for_review');
    } else if (newValue === 1) {
      setSelectedCategory('goals_for_review');
    } else if (newValue === 2) {
      setSelectedCategory('pending_appraisals');
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleBackToDashboard = () => {
    setSelectedEmployee(null);
    setActiveTab(0);
  };

  const dashboardCards = [{
    key: 'submitted_for_review',
    title: 'Goals Submitted for Review',
    icon: Assessment,
    colors: {
      background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
      icon: '#1976D2',
      text: '#1976D2',
      border: '#1976D2'
    },
    getCount: dashboardCardDetails?.submitted_for_review || 0
  },
  {
    key: 'pending_goals',
    title: 'Pending Goals',
    icon: Task,
    colors: {
      background: 'linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)',
      icon: '#FF9800',
      text: '#FF9800',
      border: '#FF9800'
    },
    getCount: dashboardCardDetails?.pending_goals || 0
  },
  {
    key: 'acknowledged_appraisals',
    title: 'Acknowledged Appraisals',
    icon: ThumbUp,
    colors: {
      background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
      icon: '#4CAF50',
      text: '#4CAF50',
      border: '#4CAF50'
    },
    getCount: dashboardCardDetails?.acknowledged_appraisals || 0
  },
  {
    key: 'pending_appraisals',
    title: 'Pending Appraisals',
    icon: AccessTime,
    colors: {
      background: 'linear-gradient(135deg, #FCE4EC 0%, #F8BBD0 100%)',
      icon: '#E91E63',
      text: '#E91E63',
      border: '#E91E63'
    },
    getCount: dashboardCardDetails?.pending_appraisals || 0
  }];

  const handleCategoryClick = async (categoryKey) => {
    setSelectedCategory(categoryKey);
    setLoading(true);

    try {
      let response;
      let apiStatus;

      // Map to correct API status values
      if (categoryKey === 'submitted_for_review') {
        apiStatus = 'Submitted For Review';
        response = await axios(localAxiosGet(
          `/performancemanagement/getEmployeesByStatus?status=${apiStatus}&reporting_manager_id=${userId}`
          //  `/performancemanagement/getEmployeesByStatus?status=Submitted For Review&reporting_manager_id=249`
        ));
        setGoalsTable(response.data.result.data || []);
      }
      else if (categoryKey === 'pending_goals') {
        apiStatus = 'Pending';
        response = await axios(localAxiosGet(
          `/performancemanagement/getEmployeesByStatus?status=${apiStatus}&reporting_manager_id=${userId}`
        ));
        setGoalsTable(response.data.result.data || []);
      }
      else if (categoryKey === 'acknowledged_appraisals') {
        apiStatus = 'Acknowledged';
        response = await axios(localAxiosGet(
          `/performancemanagement/getAppraisalsByStatus?status=${apiStatus}&report_manager_id=${userId}&goal_period=Yearly`
        ));
        setGoalsTable(response.data.result || []);
      }
      else if (categoryKey === 'pending_appraisals') {
        apiStatus = 'Pending';
        response = await axios(localAxiosGet(
          `/performancemanagement/getAppraisalsByStatus?status=${apiStatus}&report_manager_id=${userId}&goal_period=Yearly`
        ));
        setGoalsTable(response.data.result || []);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || 'An error occurred',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleViewAllClick = () => {

  //   const isGoalCategory = selectedCategory.includes('goals');
  //   if (isGoalCategory) {
  //     setActiveTab(1);
  //   } else {
  //     setActiveTab(2);
  //   }
  // };
  const handleViewAllClick = () => {
    // submitted_for_review and pending_goals → Goals tab
    const isGoalCategory =
      selectedCategory === 'submitted_for_review' ||
      selectedCategory === 'pending_goals';
  
    if (filteredEmployees.length > 0) {
      setSelectedEmployee(filteredEmployees[0]); // Pick first employee
    }
  
    if (isGoalCategory) {
      setActiveTab(1); // Goals tab
    } else {
      setActiveTab(2); // Appraisals tab
    }

     // Scroll smoothly to top after tab change
  window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  
  const renderDashboard = () => {
    const isGoalCategory = selectedCategory.includes('goals');
    const isAppraisalCategory = selectedCategory.includes('appraisals');

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
        {loading && <Loader />}

        <Grid container spacing={3} sx={{ mt: 3, mb: 3 }}>
          {dashboardCards.map((category) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={category.key}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  background: category.colors.background,
                  height: '100%',
                  cursor: 'pointer',
                  border: selectedCategory === category.key ? `2px solid ${category.colors.border}` : 'none',
                  transition: 'transform 0.2s, border 0.2s',
                  '&:hover': {
                    transform: 'scale(1.03)'
                  }
                }}
                onClick={() => handleCategoryClick(category.key)}
              >
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <category.icon sx={{ fontSize: 50, color: category.colors.icon }} />
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {category.title}
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{ mt: 1, fontWeight: 'bold', color: category.colors.text }}
                  >
                    {category.getCount}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            {dashboardCards.find(c => c.key === selectedCategory)?.title || 'Goals Submitted for Review'}
          </Typography>


          <TableContainer>
            <Table size="small">
              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Employee</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Position</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Department</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Last Review</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                { filteredEmployees.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                      <Typography variant="body2" color="textSecondary">
                        No data available for selected category
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredEmployees.map((emp) => {
                    // For goals API response
                    const employeeName = emp.user
                      ? `${emp.user.first_name || ''} ${emp.user.last_name || ''}`.trim()
                      : emp.employee_data
                        ? `${emp.employee_data.first_name || ''} ${emp.employee_data.last_name || ''}`.trim()
                        : 'Unknown Employee';

                    const position = emp.user?.designation?.designation
                     
                      || 'Unknown Position';

                    const department = emp.user?.department?.department
                     
                      || 'Unknown Department';

                    const avatarChar = employeeName.charAt(0);

                    return (
                      <TableRow key={emp.id || emp.emp_id} hover>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar
                              alt={employeeName}
                              sx={{ width: 30, height: 30, mr: 1 }}
                            >
                              {avatarChar}
                            </Avatar>
                            {employeeName}
                          </Box>
                        </TableCell>
                        <TableCell>{position}</TableCell>
                        <TableCell>{department}</TableCell>
                        <TableCell>
                          {getStatusChip(emp.status)}
                        </TableCell>
                        <TableCell>
                          {emp.updatedAt ? new Date(emp.updatedAt).toLocaleDateString() : 'N/A'}
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleViewAllClick}
            >
              View All Employees
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  };

  const renderGoalsReview = () => {
    return (

      <EmployeeGoalsReview employee={selectedEmployee} />

    );
  };

  const renderAppraisalReview = () => {
    return (

      <EmployeePerformanceReview employee={selectedEmployee} />
    )
  };

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return renderDashboard();
      case 1:
        return renderGoalsReview();
      case 2:
        return renderAppraisalReview();
      default:
        return renderDashboard();
    }
  };


  return (
    <Box sx={{ p: 3 }}>
      <motion.div
        initial={{
          opacity: 0,
          y: -20
        }}
        animate={{
          opacity: 1,
          y: 0
        }}
        transition={{
          duration: 0.5
        }}
      >
        <Box mb={2}>
          <Box>
            <Typography variant="h5"
              sx={{
                fontWeight: 600,
                color: '#1e293b',
              }}>
              Performance and Appraisals Review
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label="Dashboard" icon={<Assessment />} iconPosition="start" />
              <Tab label="Employee Goals" icon={<Group />} iconPosition="start" />
              <Tab label="Employee Appraisals" icon={<Person />} iconPosition="start" />
            </Tabs>
          </Box>
        </Box>

        {renderContent()}
      </motion.div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ManagerPerformanceReviewDashboard;